import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { type RootState } from '../../../../state/store';
import { subRModuleMap } from '../../helpers/utils';
import InventorySubRBaseLayout from '../inventory/BaseLayout';
import OperationsSubRBaseLayout from '../operations/BaseLayout';

const SubRLayout = () => {
  const { company_details } = useSelector((state: RootState) => state.company);
  const urlDateValidated = useSelector(
    (state: RootState) => state.filters.urlDateValidated ?? false
  );
  const isMaintenance = company_details?.maintenance_mode?.enabled;
  const [isValidSubRModule, setIsValidSubRModule] = useState(false);

  const routeMatch = useParams();

  useEffect(() => {
    if (routeMatch.dashboard && routeMatch.widget) {
      const dashboard = routeMatch.dashboard ?? '';
      const widget = routeMatch.widget;
      const subRModule = `${dashboard}.${widget}`;
      if (subRModuleMap[subRModule]) {
        setIsValidSubRModule(true);
      } else {
        window.location.href = '/';
      }
    }
  }, [routeMatch.dashboard, routeMatch.widget]);

  const renderSubR = () => {
    switch (routeMatch.dashboard) {
      case 'inventory':
        return <InventorySubRBaseLayout widget={routeMatch.widget} />;
      case 'operations':
        return <OperationsSubRBaseLayout widget={routeMatch.widget} />;
      default:
        return null;
    }
  };
  if (isValidSubRModule && urlDateValidated) {
    return <Wrapper isMaintenance={isMaintenance}>{renderSubR()}</Wrapper>;
  }
  return null;
};

const Wrapper = styled.div<{ isMaintenance: boolean }>`
  margin: 0 50px 50px 50px;
  padding-top: ${({ isMaintenance }) => (isMaintenance ? '60px' : '0px')};
`;
export default SubRLayout;
